import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MENU_KIDS, RecordItem } from '@app/models/record.model';
import { ApiService } from '@app/services/api.service';
import { ScheduleService } from '@app/services/schedule.service';
import { WebviewService } from '@app/services/webview.service';
import { NoteDisplayInputParams } from '@care-connect-japan/ckweblib/lib/data/schema/params/library-params';

@Component({
  selector: 'app-record-item',
  templateUrl: './record-item.component.html',
  styleUrls: ['./record-item.component.scss'],
})
export class RecordItemComponent implements OnChanges {
  @Input() record!: RecordItem;
  @Input() titles?: any[] = [];
  @Input() isFull?: boolean = false;
  // img?: string = undefined;
  noteParam?: NoteDisplayInputParams = undefined;
  menuScreen = MENU_KIDS;
  fileIcon: string = 'documentIcon';
  get screen() {
    return localStorage.getItem('menu') || MENU_KIDS.AREDASITE
  }

  get isDockbn() {
    return this.record.dockbn === 1;
  }

  constructor(
    public scheduleService: ScheduleService,
    private cd: ChangeDetectorRef,
    private apiService: ApiService,
    private webviewService: WebviewService,
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    // this.getIconByType();
    let _noteParam = this.noteParam;
    if (changes['titles']) {
      let title = this.titles?.find(x => x.ttlkbn === this.record.ttlkbn && x.ttlcd === this.record.ttlcd);
      if (!title) return;
      let note = { ...this.record };
      // if (note.noteblobs && note.noteblobs[0]) {
      //   const img = note.noteblobs[0];
      //   const { ext, bldata } = img;
      //   const base64ImageType = `data:image/${ext?.replace('.', '') || 'png'};base64,`;
      //   this.img = base64ImageType + bldata?.replace('\'', '');
      // }
      _noteParam = {
        noteData: note,
        device: 1,
        titleObject: title,
        showLimit: -1
      }
      this.noteParam = _noteParam;
    }
    this.cd.detectChanges();
  }

  get handover() {
    return Boolean(this.record.pickupflg);
  }

  truncate(text: string, count: number): string {
    return text?.length > count ? `${text.slice(0, count)}...` : text;
  }

  // getIconByType() {
  //   let icon = 'documentIcon';
  //   const type = (this.record.fileContent?.fileName ?? '').split('.').pop() ?? '';
  //   switch (type.toUpperCase()) {
  //     case MIME_TYPE.PDF:
  //       icon = 'pdfIcon';
  //       break;
  //     case MIME_TYPE.XLS:
  //     case MIME_TYPE.XLSX:
  //       icon = 'excelIcon';
  //       break;
  //     case MIME_TYPE.DOC:
  //     case MIME_TYPE.DOCX:
  //       icon = 'wordIcon';
  //       break;
  //     case MIME_TYPE.PPT:
  //     case MIME_TYPE.PPTX:
  //       icon = 'powerpointIcon';
  //       break;
  //     case MIME_TYPE.MP4:
  //       icon = 'videoIcon';
  //       break;
  //     default:
  //       icon = 'documentIcon';
  //       break;
  //   }
  //   this.fileIcon = icon;
  // }

  // async handleViewFile() {
  //   const fileId = this.record.fileContent?.fileId;
  //   if(!fileId) return;
  //   const payload: RecordFilePayload = { fileId: Number(fileId) };
  //   this.apiService.getRecordFile(payload)
  //     .pipe(
  //       take(1),
  //       catchError(() => { return EMPTY; })
  //     )
  //     .subscribe((res) => {
  //       if(!res) return; 
  //       this.webviewService.sendCasefile(res);
  //     })
  // }
}
